var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
var DatasetRuleService = services.DatasetRuleService, PermissionService = services.PermissionService, DatasetService = services.DatasetService;
export var loadGroups = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var allGroups, availableGroups, groups, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: 'LOAD_GROUPS_REQUEST' });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, PermissionService.getGroups(appId)];
            case 2:
                allGroups = (_a.sent()).objects;
                availableGroups = allGroups.filter(function (group) { return group.type === 'app'; });
                groups = availableGroups.map(function (_a) {
                    var id = _a.id, label = _a.label;
                    return ({
                        id: id,
                        label: label,
                    });
                });
                dispatch({ type: 'LOAD_GROUPS_SUCCESS', groups: groups });
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                dispatch({ type: 'LOAD_GROUPS_FAILURE', err: err_1 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
export var loadDatasetRules = function (datasetId, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var rules, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'LOAD_DATASET_RULES_REQUEST', datasetId: datasetId });
                    return [4 /*yield*/, DatasetRuleService.fetchDatasetRules(datasetId, appId)];
                case 1:
                    rules = (_a.sent()).objects;
                    dispatch({
                        type: 'LOAD_DATASET_RULES_SUCCESS',
                        rules: rules,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch({
                        type: 'LOAD_DATASET_RULES_FAILURE',
                        error: error_1,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteDatasetRule = function (datasetId, ruleId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'DELETE_DATASET_RULE_REQUEST' });
                    return [4 /*yield*/, DatasetRuleService.deleteDatasetRule(datasetId, ruleId)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'DELETE_DATASET_RULE_SUCCESS',
                        id: ruleId,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    dispatch({
                        type: 'DELETE_DATASET_RULE_FAILURE',
                        error: error_2,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var setIsNewDatasetRuleId = function (isNew) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: 'IS_NEW_DATASET_RULE_ID',
            set: isNew,
        });
        return [2 /*return*/];
    });
}); }; };
export var createDatasetRule = function (datasetId, newRule, appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var rule, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'CREATE_DATASET_RULE_REQUEST' });
                    return [4 /*yield*/, DatasetRuleService.createDatasetRule(datasetId, newRule, appId)];
                case 1:
                    rule = (_a.sent()).object;
                    dispatch({
                        type: 'CREATE_DATASET_RULE_SUCCESS',
                        rule: rule,
                    });
                    dispatch({
                        type: 'IS_NEW_DATASET_RULE_ID',
                        set: true,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    dispatch({
                        type: 'CREATE_DATASET_RULE_FAILURE',
                        error: error_3,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var updateDatasetRule = function (datasetId, newRule) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var rule, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'UPDATE_DATASET_RULE_REQUEST' });
                    return [4 /*yield*/, DatasetRuleService.updateDatasetRule(datasetId, newRule)];
                case 1:
                    rule = (_a.sent()).object;
                    dispatch({
                        type: 'UPDATE_DATASET_RULE_SUCCESS',
                        rule: rule,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    dispatch({
                        type: 'UPDATE_DATASET_RULE_FAILURE',
                        error: error_4,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var loadDatasetColumns = function (datasetId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasetMeta, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_DATASET_COLUMNS_REQUEST' });
                return [4 /*yield*/, DatasetService.getColumns(datasetId, null)];
            case 1:
                datasetMeta = (_a.sent()).object;
                dispatch({
                    type: 'LOAD_DATASET_COLUMNS_SUCCESS',
                    datasetMeta: datasetMeta,
                });
                return [3 /*break*/, 3];
            case 2:
                error_5 = _a.sent();
                dispatch({
                    type: 'LOAD_DATASET_COLUMNS_FAILURE',
                    error: error_5,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
